module.exports = __webpack_public_path__ + "img/mv.54ceb5e0.svg";